module.exports = __webpack_public_path__ + "static/media/patton_williamson.eca69475.jpg";